module.exports = __webpack_public_path__ + "rodape_content.png?768deb24d5e593e5cce9e829fd1c8460";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rodape_content.png
// module id = 64
// module chunks = 0